export default function ColorToHex(c) {
  switch(c) {
  case 'black':
    return '#1b131d';
  case 'brown':
    return '#5b332b';
  case 'red':
    return '#c85337';
  case 'strawberry blonde':
    return '#e2bb92';
  case 'blonde':
    return '#fef6dc';
  default:
    return '#eeeeee';
  }
}
